import { type Palette } from "@mui/material"
import fp from "lodash/fp"
import type { TFunction } from "i18next"

import type { PiePlotView, RecordType } from "types/dashboard.types"
import type { IPieConfig, IPieData } from "types/piePlot.types"

import { getSequentialColor } from "helpers/utils/styles"

export const PIE_CHART_PLOT_SIZE = { lg: 240, md: 200, sm: 180 }

interface PieConfigParams {
  view: PiePlotView
  data: RecordType[]
  palette: Palette
  t: TFunction
}

export function pieConfig({ view, data, palette, t }: PieConfigParams): IPieConfig {
  const colors = view.properties.colors
  const colorsByValue = fp.indexBy("value", colors)

  const plotData = fp.flow(
    fp.map((d: RecordType, index: number) => ({
      name: t(d.nameKey as string), // handle data with no nameKey?
      value: !fp.isNil(d.value) ? Number(d.value) : Number(d._value),
      color: d.colorKey
        ? String(colorsByValue[d.colorKey as keyof typeof colorsByValue]?.hex)
        : getSequentialColor(index),
      order: d.order,
    })),
    fp.sortBy((d: IPieData) => (d.order !== undefined ? d.order : Infinity)),
  )(data)

  const filteredPlotData = plotData.filter((d) => d.value)

  const config = {
    filter: palette.glow.main,
    plotSize: PIE_CHART_PLOT_SIZE,
    plotData,
    filteredPlotData,
  }

  return config
}
